export const memberOffers = (state) => state.memberOffers;
export const isLoading = (state) => state.isLoading;
